<template lang="pug">
  Modal(ref="dlg" title="Add Group" closeable="true")
      .add-user-modal-body.ssp-form-horizontal
        .form-group
          label.ic-label Group
          .ic-control()
            .text-center.loading(v-if="loading")
              i.fa.fa-spinner.fa-pulse.fa-spin
            GroupSelect(v-model="groupId")
      div(slot="footer")
        button.btn.btn-default(type="button" @click="$refs.dlg.cancel()") Cancel
        button.btn.btn-primary.create-button(@click="save") Add
</template>

<script>
import miniToastr from 'mini-toastr'
import Security from '@/service/apis/Security'
import GroupSelect from '@/components/ssp/GroupSelect'
import Modal from '@/components/common/Modal'

export default {
  data() {
    return {
      loading: false,
      groupId: null,
      userId: this.$route.params.id
    }
  },
  methods: {
    save() {
      const req = {
        groupId: this.groupId,
        userId: this.userId
      }
      Security.addUserToGroup(this.groupId, this.userId, req)
        .then(() => {
          miniToastr.success('User added to group')
          this.$emit('success')
          this.$refs.dlg.close()
        })
    },
    open() {
      this.loading = true
      this.$refs.dlg.open()
      this.loading = false
    }
  },
  components: {
    GroupSelect,
    Modal
  }
}
</script>

<style lang="scss">
.add-user-modal-body {
  width: 500px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/core/management/user/AddGroupModal.vue